import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const Menu = ({ isMenuOpen, toggleMenu }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && isMenuOpen) {
        // Check if the click was not on the hamburger menu button
        if (!event.target.closest('.hamburger-menu')) {
          toggleMenu();
        }
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isMenuOpen, toggleMenu]);
  return (
    <nav ref={menuRef} className={`dropdown-menu ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="container">
        <div className="menu-grid">
          <div className="menu-section">
            <h3 className="menu-section-title">What We Do</h3>
            <ul className="menu-section-list">
              <li><Link to="/service-department" onClick={toggleMenu}>Service Department</Link></li>
              <li><Link to="/preconstruction" onClick={toggleMenu}>Preconstruction</Link></li>
              <li><Link to="/bim-vdc" onClick={toggleMenu}>BIM - VDC/Trimble</Link></li>
              <li><Link to="/construction-commissioning" onClick={toggleMenu}>Construction through Commissioning</Link></li>
              <li>
                <Link to="/manufacturing" onClick={toggleMenu}>Manufacturing</Link>
                <ul className="submenu-list">
                  <li><Link to="/pipe" onClick={toggleMenu}>Pipe</Link></li>
                  <li><Link to="/sheet-metal" onClick={toggleMenu}>Sheet Metal / HVACR Duct</Link></li>
                </ul>
              </li>
              <li><Link to="/technology" onClick={toggleMenu}>Technology and Innovation</Link></li>
            </ul>
          </div>
          
          <div className="menu-section">
            <h3 className="menu-section-title">Who We Are</h3>
            <ul className="menu-section-list">
              <li><Link to="/about" onClick={toggleMenu}>About Us</Link></li>
              <li><Link to="/management" onClick={toggleMenu}>Management</Link></li>
              <li><Link to="/safety" onClick={toggleMenu}>Safety</Link></li>
              <li><Link to="/careers" onClick={toggleMenu}>Career Opportunities</Link></li>
              <li><Link to="/legence" onClick={toggleMenu}>We Are Legence</Link></li>
            </ul>
          </div>
          
          <div className="menu-section">
            <h3 className="menu-section-title">Development</h3>
            <ul className="menu-section-list">
              <li><Link to="/projects" onClick={toggleMenu}>Our Projects</Link></li>
              <li><Link to="/news" onClick={toggleMenu}>News</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
